<template>
  <RefreshCcw class="loading-icon" />
</template>

<script setup lang="ts">
import { RefreshCcw } from 'lucide-vue-next'
</script>

<style scoped>
.loading-icon {
  animation: rotation 1s infinite cubic-bezier(0.19, 1, 0.22, 1);
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(-360deg);
  }
}
</style>
